import { render } from "./rotate-cw.vue?vue&type=template&id=7ed6de0d"
const script = {}
script.render = render

export default script